export const LOYALTY_TOKEN_COOKIE = 'loyalty_token'
export const LOYALTY_TOKEN_EXPIRES_COOKIE = 'loyalty_token_expires_at'
export const LOYALTY_REFRESH_COOKIE = 'loyalty_refresh_token'

interface LoyaltyTokenResponse {
  token: string
  expires_in: number
  refresh_token: string
  refresh_expires_in: number
}

interface CookieToSet {
  name: string
  value: string
  options: {
    httpOnly: boolean
    secure: boolean
    sameSite: 'lax'
    path: string
    maxAge: number
  }
}

// `loyalty_token` / `loyalty_token_expires_at` are readable client-side so the
// browser can attach `Authorization: Bearer <token>` directly on Loyalty API
// calls (see hooks/use-member-info.ts). `loyalty_refresh_token` stays
// httpOnly — only the /api/auth/* route handlers ever need it.
export function buildSessionCookies(data: LoyaltyTokenResponse): CookieToSet[] {
  const expiresAt = Date.now() + data.expires_in * 1000

  return [
    {
      name: LOYALTY_TOKEN_COOKIE,
      value: data.token,
      options: {
        httpOnly: false,
        secure: true,
        sameSite: 'lax',
        path: '/',
        maxAge: data.expires_in,
      },
    },
    {
      name: LOYALTY_TOKEN_EXPIRES_COOKIE,
      value: String(expiresAt),
      options: {
        httpOnly: false,
        secure: true,
        sameSite: 'lax',
        path: '/',
        maxAge: data.expires_in,
      },
    },
    {
      name: LOYALTY_REFRESH_COOKIE,
      value: data.refresh_token,
      options: {
        httpOnly: true,
        secure: true,
        sameSite: 'lax',
        path: '/',
        maxAge: data.refresh_expires_in,
      },
    },
  ]
}

export const SESSION_COOKIE_NAMES = [
  LOYALTY_TOKEN_COOKIE,
  LOYALTY_TOKEN_EXPIRES_COOKIE,
  LOYALTY_REFRESH_COOKIE,
]
